import React, { Component } from 'react';
// import Img from 'react-image'
// import Image from './Image';

export default class Page extends Component {

	willUnmount = false;

	constructor(params){
		super(params);

		this.state = {
			page: params.page,
			pageSize: params.pageSize,
			loaded: false,
		}
	}

	componentWillUnmount(){
		this.willUnmount = true;
	}

	getTranslateX(){
		const {width} = this.state.pageSize;

		switch(this.props.position)
		{
			case 'left':
				return 0;
			case 'right':
				return width;
			default: 
				return 0;
		}
		
	}

	onLoad(){
		if(this.willUnmount)
			return;

		this.setState({loaded: true});
	}
	
   render() {
		const {page, loaded} = this.state;
		const {width, height} = this.state.pageSize;

		const pageStyle = {
			width,
			height,
			// backgroundColor: '#212121',
			position: 'relative',
			display: 'inline-block',
			oveflow: 'hidden',
		}
		const imgStyle = {
			visibility: loaded ? 'visible' : 'hidden',
			opacity: loaded ? 1 : 0,
			transition: 'opacity 0.2s ease-out'
		}
      return (
         <div style={pageStyle}>
				{!loaded ? <div className={"preloader"}><i className={"fa-5x fas fa-spinner fa-spin"}></i></div> : null}
				<img style={imgStyle} draggable={false} onLoad={this.onLoad.bind(this)}  onDragStart={() => false} src={page.img} alt={page.img} />
				{/* <Image onLoad={() => this.setState({loaded: true})} src={page.img} /> */}
			</div>
		);
   }
}
   